module.exports = __webpack_public_path__ + "img/speech_7.9497a404.jpeg";